import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';
import endpoints from '../../../config/endpoints';
import moment from 'moment';

import http from '../../shared/http';
import intl from '../../shared/intl';
import checkPermissions from '../../shared/check-permissions';

import cloneDeep from 'lodash/cloneDeep';

import createForm from '../components/form/index';

const form = createForm({
	namespace: 'discountsEdit',
	stateNodeName: 'form'
});

// action types
const FETCH_DATA_SUCCESS = 'discounts-edit/fetch-data-success';
const FETCH_DATA_ERROR = 'discount-edit/fetch-data-error';

const TOGGLE_PROGRESS_BAR = 'discounts-edit/toggle-progress-bar';

// permissions
export const allowedPermissions = {
	view: 'discounts_list',
	edit: 'discounts_create'
};

// initial state
const initialState = {
	data: null,
	form: form.initialState,
	defaultLanguage: 'en',
	showProgressBar: false,
	error: false
};

// actions
export const actions = Object.assign(
	{
		fetchData: props => (dispatch, getState) => {
			const id = props && props.params && props.params.id;
			if (!id) {
				return dispatch({ type: FETCH_DATA_SUCCESS, payload: {} });
			}
			return http({
				url: `${endpoints.DISCOUNTS.SINGLE.replace('{id}', id)}`,
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
			})(dispatch);
		},

		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		})
	},
	form.actions
);

const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			return initialState;
		},
		[FETCH_DATA_SUCCESS]: (state, action) => {
			const data = action.payload.data || {};
			data.discounts_end_at = data.discounts_end_at && moment(data.discounts_end_at).format('DD-MM-YYYY');
			return {
				...state,
				data,
				showProgressBar: false,
				error: false
			};
		},
		[FETCH_DATA_ERROR]: (state, action) => ({ ...state, error: true, showProgressBar: false }),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar })
	},
	form.reducers
);

// reducers
export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.discountsEdit.data,
	getFormData: form.selectors.getFormData,
	getProgressBar: state => state.discountsEdit.showProgressBar,
	getIntl: state => intl(state),
	getCan: state => checkPermissions(state, allowedPermissions),
	getError: state => state.newsEdit.error
};




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/discounts/edit/index.js